import { Component, OnInit } from "@angular/core";
import moment from "moment/moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { locale as italian } from "../../../../i18n/it";
import { RefundsService } from "../../../../auth/service/refunds.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IRefundKilometerForm } from "app/auth/models/refunds";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-refunds-kilometers",
  templateUrl: "./refunds-kilometers.component.html",
  styleUrls: ["./refunds-kilometers.component.scss"]
})
export class RefundsKilometersComponent implements OnInit {
  public contentHeader: IContentHeader;
  public refundsList: any[] = [];
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public categories: any = [];
  public selectedMonth: string = moment().format("M");
  public selectedYear: string = moment().format("YYYY");
  public statuses_labels: any;
  public searchStatus: number = 10;
  public availableMonths: any = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public availableYears: any = [];
  public me: ICurrentUser;
  public refunds: any = [];
  public isEditBonusExtra: boolean = false;
  public isAddBonusExtra: boolean = false;
  private previous_bonus_extra_field: any = null;
  public isEditBonus: boolean = false;
  public isAddBonus: boolean = false;
  private previous_bonus_field: any = null;

  constructor(
    public _refundService: RefundsService,
    public _utilService: UtilsService,
    public _userService: UserService,
    public _authenticationService: AuthenticationService,
    private _router: Router
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.REFUND_KM,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management"
          },
          {
            name: italian.data.MENU.REFUND_KM,
            isLink: false
          }
        ]
      }
    };

    const currentYear = moment().format("YYYY");
    for (let i = 2022; i <= Number(currentYear); i++) {
      this.availableYears.push(String(i));
    }
  }

  async ngOnInit() {
    this._utilService.showLoading();
    this.me = await this._authenticationService.getCurrentUser();
    if (!this._authenticationService.hasCapability("show_menu_refunds_kilometers")) {
      this._utilService.hideLoading();
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.statuses_labels = await this._utilService.translate("STATUS");
    await this.loadRefunds();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadRefunds() {
    this._utilService.showLoading();
    this.refundsList = await this._refundService.getRefundKilometers(this.selectedMonth, this.selectedYear);
    const notEnvoy: string = await this._utilService.translate("NOT_SENDED");
    const envoy: string = await this._utilService.translate("SENDED");
    const signatureToApprove: string = await this._utilService.translate("SIGNATURE_TO_APPROVE");
    const completed: string = await this._utilService.translate("COMPLETED");
    this.refundsList.map((item: any) => {
      item.document_status = 0;
      if (item.document_status === 2) {
        item.enabled_label = signatureToApprove;
      } else if (item.document_status === 3) {
        item.enabled_label = completed;
      } else if (item.document_status === 0) {
        item.enabled_label = notEnvoy;
      } else if (item.document_status === 1) {
        item.enabled_label = envoy;
      }
    });

    await this.reportsFilterList();
    this._utilService.hideLoading();
  }

  async reportsFilterList() {
    let items: any = this.refundsList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) => item.complete_name.toLowerCase().includes(keywords));
    }

    if (this.searchStatus < 5) {
      items = items.filter((item: any) => item.document.status === Number(this.searchStatus));
    }

    this.refunds = items;
    await this.refunds.map((item: any) => {
      item.edit_bonus_extra = false;
      item.add_bonus_extra = false;
      item.edit_bonus = false;
      item.add_bonus = false;
    });
  }

  formatLabel(month: number) {
    //Refactor della label filtro mese
    const date = moment();
    date.set("month", month - 1);
    return date.format("MMMM");
  }

  //Funzioni per edit bonus
  async openEditBonus(selectedEmployee: any) {
    let thereIsAnEditOpen: any; /*Controllo per capire se ci sono bonus aperti in edit*/
    this.refunds.map((user: any) => {
      if (user.edit_bonus_extra || user.add_bonus_extra || user.edit_bonus || user.add_bonus) {
        return (thereIsAnEditOpen = true);
      }
    });
    if (thereIsAnEditOpen > 0) {
      /*Se c'è un bonus in edit chiediamo all'utente di salvare o annullare prima di poter aprire un altro edit*/
      await this._utilService.showSWALError({ text: "SAVE_FIRST_REFUND_OPEN" });
      return false;
    }
    if (selectedEmployee.bonus) {
      //Nel caso sia presente bonus significa che siamo in edit
      selectedEmployee.edit_bonus = true;
      this.isEditBonus = true;
      //A ogni apertura salvo i valori che sono inseriti cosi da poter gestire l'annulla e riportare i dati a come erano stati inseriti
      this.previous_bonus_field = selectedEmployee.bonus;
      selectedEmployee.bonus = this._utilService.addDotsToNumber(selectedEmployee.bonus);
    } else {
      selectedEmployee.add_bonus = true;
      this.isAddBonus = true;
    }
  }

  /*Salvataggio per il singolo rimborso*/
  async saveBonus(selectedEmployee: any) {
    if (!this._authenticationService.hasCapability("refunds_kilometers_manage_bonus")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    //EDIT
    if (this.isEditBonus && selectedEmployee.user_costs_id) {
      selectedEmployee.edit_bonus = false;
      this.isEditBonus = false;
      const data: { bonus: string } = {
        bonus: selectedEmployee.bonus
      };
      this._utilService.showLoading();
      await this._refundService
        .editRefundKilometers(selectedEmployee.user_costs_id, data)
        .then(async () => {
          this._utilService.hideLoading();
          selectedEmployee.edit_bonus = false;
          this.isEditBonus = false;
          this.previous_bonus_field = null;
          await this.loadRefunds();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_BONUS" });
        })
        .catch(async () => {
          this._utilService.hideLoading();
          selectedEmployee.bonus = this.previous_bonus_field;
          this.previous_bonus_field = null;
          await this._utilService.showSWALError({ text: "ERROR_EDIT_BONUS" });
        });
    } else {
      //CREATE
      const data: IRefundKilometerForm = {
        user_hash: selectedEmployee.hash,
        bonus: selectedEmployee.bonus,
        bonus_extra: selectedEmployee.bonus_extra,
        month: selectedEmployee.month,
        year: selectedEmployee.year
      };
      this._utilService.showLoading();
      await this._refundService
        .addRefundKilometers(data)
        .then(async () => {
          this._utilService.hideLoading();
          selectedEmployee.add_bonus = false;
          this.isAddBonus = false;
          await this.loadRefunds();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_ADD_BONUS" });
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_ADD_BONUS" });
        });
    }
  }

  /*Annulla per il singolo bonus riporta i dati a quelli precedentemente inseriti (solo nel caso di edit) nel caso di add semplice reset*/
  async cancelBonus(selectedEmployee: any) {
    if (!this._authenticationService.hasCapability("refunds_kilometers_manage_bonus")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.isEditBonus) {
      //Nel caso di edit
      selectedEmployee.bonus = this.previous_bonus_field;
      this.previous_bonus_field = null;
      selectedEmployee.edit_bonus = false;
      this.isEditBonus = false;
    } else {
      selectedEmployee.add_bonus = null;
      this.isAddBonus = false;
    }
  }

  //Fine funzioni per edit bonus

  //Funzioni per edit bonus extra
  async openEditBonusExtra(selectedEmployee: any) {
    let thereIsAnEditOpen: any; /*Controllo per capire se ci sono rimborsi aperti in edit*/
    this.refunds.map((user: any) => {
      if (user.edit_bonus_extra || user.add_bonus_extra || user.edit_bonus || user.add_bonus) {
        return (thereIsAnEditOpen = true);
      }
    });
    if (thereIsAnEditOpen > 0) {
      /*Se c'è un rimborso in edit chiediamo all'utente di salvare o annullare prima di poter aprire un altro edit*/
      await this._utilService.showSWALError({ text: "SAVE_FIRST_REFUND_OPEN" });
      return false;
    }
    if (selectedEmployee.bonus_extra) {
      //Nel caso sia presente bonus extra significa che siamo in edit
      selectedEmployee.edit_bonus_extra = true;
      this.isEditBonusExtra = true;
      //A ogni apertura salvo i valori che sono inseriti cosi da poter gestire l'annulla e riportare i dati a come erano stati inseriti
      selectedEmployee.bonus_extra = selectedEmployee.bonus_extra || "0,00";
      this.previous_bonus_extra_field = selectedEmployee.bonus_extra;
      selectedEmployee.bonus_extra = this._utilService.addDotsToNumber(selectedEmployee.bonus_extra);
    } else {
      selectedEmployee.add_bonus_extra = true;
      this.isAddBonusExtra = true;
    }
  }

  /*Salvataggio per bonus extra*/
  async saveBonusExtra(selectedEmployee: any) {
    if (!this._authenticationService.hasCapability("refunds_kilometers_manage_bonus")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    //EDIT
    if (this.isEditBonusExtra || selectedEmployee.user_costs_id) {
      selectedEmployee.edit_bonus_extra = false;
      this.isEditBonusExtra = false;
      const data: { bonus_extra: string } = {
        bonus_extra: selectedEmployee.bonus_extra
      };
      this._utilService.showLoading();
      await this._refundService
        .editRefundKilometers(selectedEmployee.user_costs_id, data)
        .then(async () => {
          this._utilService.hideLoading();
          selectedEmployee.edit_bonus_extra = false;
          this.isEditBonusExtra = false;
          this.previous_bonus_extra_field = null;
          await this.loadRefunds();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_BONUS_EXTRA" });
        })
        .catch(async () => {
          this._utilService.hideLoading();
          selectedEmployee.bonus_extra = this.previous_bonus_extra_field;
          this.previous_bonus_extra_field = null;
          await this._utilService.showSWALError({ text: "ERROR_EDIT_BONUS_EXTRA" });
        });
    } else {
      //CREATE
      const data: { user_hash: string; bonus: string; bonus_extra: string; month: number; year: number } = {
        user_hash: selectedEmployee.hash,
        bonus: selectedEmployee.bonus,
        bonus_extra: selectedEmployee.bonus_extra,
        month: selectedEmployee.month,
        year: selectedEmployee.year
      };
      this._utilService.showLoading();
      await this._refundService
        .addRefundKilometers(data)
        .then(async () => {
          this._utilService.hideLoading();
          selectedEmployee.add_bonus_extra = false;
          this.isAddBonusExtra = false;
          await this.loadRefunds();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_ADD_BONUS_EXTRA" });
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_ADD_BONUS_EXTRA" });
        });
    }
  }

  /*Annulla per il singolo rimborso riporta i dati a quelli precedentemente inseriti (solo nel caso di edit) nel caso di add semplice reset*/
  async cancelBonusExtra(selectedEmployee: any) {
    if (!this._authenticationService.hasCapability("refunds_kilometers_manage_bonus")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.isEditBonusExtra) {
      //Nel caso di edit
      selectedEmployee.bonus_extra = this.previous_bonus_extra_field;
      this.previous_bonus_extra_field = null;
      selectedEmployee.edit_bonus_extra = false;
      this.isEditBonusExtra = false;
    } else {
      selectedEmployee.add_bonus_extra = null;
      this.isAddBonusExtra = false;
    }
  }

  //Cancella bonus extra per il dipendente selezionato
  async deleteBonusExtra(selectedEmployee: any) {
    if (!this._authenticationService.hasCapability("refunds_kilometers_manage_bonus")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._refundService
      .deleteRefundKilometers(selectedEmployee.user_costs_id)
      .then(async () => {
        this._utilService.hideLoading();
        selectedEmployee.edit_bonus_extra = false;
        this.isEditBonusExtra = false;
        await this.loadRefunds();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_BONUS_EXTRA" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_DELETE_BONUS_EXTRA" });
      });
  }

  //Fine funzioni per edit bonus extra

  //Fine funzioni per edit bonus_extra

  formatBonusExtraValue(selectedEmployee: any) {
    selectedEmployee.bonus_extra = this._utilService.addDotsToNumber(selectedEmployee.bonus_extra);
  }

  formatBonusValue(selectedEmployee: any) {
    selectedEmployee.bonus = this._utilService.addDotsToNumber(selectedEmployee.bonus);
  }

  //Funzioni azioni con il backend
  async generateDocument(user_hash: string) {
    this._utilService.showLoading();
    await this._utilService
      .basic_post("/refund/generate-kilometers-document", {
        user_hash,
        month: Number(this.selectedMonth),
        year: Number(this.selectedYear)
      })
      .then(async () => {
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_REFUND_DOCUMENT" }).then(async () => {
          await this.loadRefunds();
        });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_GENERATE_REFUND_DOCUMENT" });
      });
  }

  viewDocument(row: any) {
    this._router.navigate(["/dashboard/single-document-file/", row.document.document_id], { queryParams: { hash: row.hash } });
  }
}
